//import { userConstants } from "../_constants";

localStorage.removeItem("user");
let user           = {};                       //JSON.parse(localStorage.getItem("user")); //menis
const initialState = { loggedIn: true, user }; //user ? { loggedIn: true, user } : { loggedIn: false };

export function authentication(state = initialState, action) {
  //console.log("authentication");
  // console.log("initialState");
  // console.log(initialState);
  // switch (action.type) {
  //   case userConstants.LOGIN_REQUEST:{
  //     return {
  //       loggingIn: true,
  //       user: action.user
  //     };
  //   }
  //   case userConstants.LOGIN_SUCCESS:{
  //     return {
  //       ...state,
  //       loggedIn: true,
  //       user: action.user
  //     };
  //   }
  //   case userConstants.LOGIN_FAILURE:{
  //     return {};
  //   }
  //   case userConstants.LOGOUT:{
  //     return { ...state, loggedIn: false, user: action.user };
  //   }
  //   default:{
  //     return state;
  //   }
  // }
  return { loggingIn:true, user:{} };
}
